/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckExchangeEligibilityResponseDto } from '../models/CheckExchangeEligibilityResponseDto';
import type { CreateExchangeDto } from '../models/CreateExchangeDto';
import type { CreateSalesOrderDto } from '../models/CreateSalesOrderDto';
import type { CreateSalesOrderWithItemsDto } from '../models/CreateSalesOrderWithItemsDto';
import type { PartialReturnSalesOrderDto } from '../models/PartialReturnSalesOrderDto';
import type { PostSalesCountsResponseDto } from '../models/PostSalesCountsResponseDto';
import type { ReturnSalesOrderDto } from '../models/ReturnSalesOrderDto';
import type { SaleDateHistoryEntryDto } from '../models/SaleDateHistoryEntryDto';
import type { SalesOrder } from '../models/SalesOrder';
import type { SalesOrderListResponseDto } from '../models/SalesOrderListResponseDto';
import type { SoldItemsListResponseDto } from '../models/SoldItemsListResponseDto';
import type { SoldPieceDetailResponseDto } from '../models/SoldPieceDetailResponseDto';
import type { UpdateSalesOrderCommercialDto } from '../models/UpdateSalesOrderCommercialDto';
import type { UpdateSalesOrderDeliveryDto } from '../models/UpdateSalesOrderDeliveryDto';
import type { UpdateSalesOrderDto } from '../models/UpdateSalesOrderDto';
import type { UpdateSalesOrderSaleDateDto } from '../models/UpdateSalesOrderSaleDateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SalesOrdersService {
  /**
   * Create a new sales order
   * @param requestBody
   * @returns SalesOrder Sales order created successfully
   * @throws ApiError
   */
  public static salesOrdersControllerCreate(
    requestBody: CreateSalesOrderDto,
  ): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid order data`,
      },
    });
  }
  /**
   * Get sales orders with comprehensive filtering
   * @param page Page number
   * @param limit Items per page
   * @param orderCode Filter by order code (partial match)
   * @param branchReceiptCode Filter by branch receipt number (partial match)
   * @param status Filter by payment / lifecycle status
   * @param deliveryStatus Filter by customer handoff delivery status
   * @param fulfillmentStatus Filter by mixed-branch fulfillment / shipping status
   * @param salesChannel Filter by sales channel
   * @param priorityLevel Filter by priority level
   * @param locationId Filter by location ID
   * @param customerId Filter by customer ID
   * @param createdById Filter by user who created the order
   * @param startDate Filter orders created from this date (ISO format)
   * @param endDate Filter orders created to this date (ISO format)
   * @param lastPaymentDateFrom Filter by last payment date from (ISO format)
   * @param lastPaymentDateTo Filter by last payment date to (ISO format)
   * @param nextPaymentDueFrom Filter by next payment due date from (ISO format)
   * @param nextPaymentDueTo Filter by next payment due date to (ISO format)
   * @param minTotalAmount Minimum total amount
   * @param maxTotalAmount Maximum total amount
   * @param hasDiscount Filter orders with discount applied
   * @param hasPartialPayment Filter orders with partial payment
   * @param hasInstallments Filter orders with installments
   * @param postSalesKpi Post-sales KPI bucket: pending_payment | completed | returned | exchanged
   * @param searchTerm Search term for full-text search across order code, customer name, and email
   * @param customerSearchTerm Filter by customer name (partial match)
   * @param customerPhone Filter by customer phone (partial match)
   * @param createdInLastHours Filter orders created in the last X hours
   * @param isOverdue Filter overdue orders (next payment due date has passed)
   * @param includeItems Include order items in response
   * @param includePayments Include order payments in response
   * @param includeReceipts Include order receipts in response
   * @param sortBy Sort column (whitelist). Without it: commercial sale date, newest first.
   * @param sortOrder ASC or DESC (default DESC)
   * @returns SalesOrderListResponseDto Sales orders retrieved successfully with pagination
   * @throws ApiError
   */
  public static salesOrdersControllerFindAll(
    page: number = 1,
    limit: number = 10,
    orderCode?: string,
    branchReceiptCode?: string,
    status?:
      | 'DRAFT'
      | 'CONFIRMED'
      | 'PARTIAL_PAID'
      | 'PAID'
      | 'DELIVERED'
      | 'CANCELLED'
      | 'REFUNDED',
    deliveryStatus?: 'NONE' | 'PARTIAL' | 'FULL' | 'CANCELLED',
    fulfillmentStatus?: 'NOT_REQUIRED' | 'PENDING' | 'COMPLETED' | 'FAILED' | 'CANCELLED',
    salesChannel?: 'IN_STORE' | 'ONLINE' | 'PHONE' | 'WHATSAPP',
    priorityLevel?: 'LOW' | 'NORMAL' | 'HIGH' | 'URGENT',
    locationId?: number,
    customerId?: number,
    createdById?: string,
    startDate?: string,
    endDate?: string,
    lastPaymentDateFrom?: string,
    lastPaymentDateTo?: string,
    nextPaymentDueFrom?: string,
    nextPaymentDueTo?: string,
    minTotalAmount?: number,
    maxTotalAmount?: number,
    hasDiscount?: boolean,
    hasPartialPayment?: boolean,
    hasInstallments?: boolean,
    postSalesKpi?: 'pending_payment' | 'completed' | 'returned' | 'exchanged',
    searchTerm?: string,
    customerSearchTerm?: string,
    customerPhone?: string,
    createdInLastHours?: number,
    isOverdue?: boolean,
    includeItems: boolean = false,
    includePayments: boolean = false,
    includeReceipts: boolean = false,
    sortBy?:
      | 'orderCode'
      | 'branchReceiptCode'
      | 'customerName'
      | 'locationName'
      | 'totalAmount'
      | 'saleDate'
      | 'status',
    sortOrder?: 'ASC' | 'DESC',
  ): CancelablePromise<SalesOrderListResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders',
      query: {
        page: page,
        limit: limit,
        orderCode: orderCode,
        branchReceiptCode: branchReceiptCode,
        status: status,
        deliveryStatus: deliveryStatus,
        fulfillmentStatus: fulfillmentStatus,
        salesChannel: salesChannel,
        priorityLevel: priorityLevel,
        locationId: locationId,
        customerId: customerId,
        createdById: createdById,
        startDate: startDate,
        endDate: endDate,
        lastPaymentDateFrom: lastPaymentDateFrom,
        lastPaymentDateTo: lastPaymentDateTo,
        nextPaymentDueFrom: nextPaymentDueFrom,
        nextPaymentDueTo: nextPaymentDueTo,
        minTotalAmount: minTotalAmount,
        maxTotalAmount: maxTotalAmount,
        hasDiscount: hasDiscount,
        hasPartialPayment: hasPartialPayment,
        hasInstallments: hasInstallments,
        postSalesKpi: postSalesKpi,
        searchTerm: searchTerm,
        customerSearchTerm: customerSearchTerm,
        customerPhone: customerPhone,
        createdInLastHours: createdInLastHours,
        isOverdue: isOverdue,
        includeItems: includeItems,
        includePayments: includePayments,
        includeReceipts: includeReceipts,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
    });
  }
  /**
   * Create complete sales order with items and payments
   * @param requestBody
   * @returns SalesOrder Complete sales order created successfully
   * @throws ApiError
   */
  public static salesOrdersControllerCreateWithItems(
    requestBody: CreateSalesOrderWithItemsDto,
  ): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/with-items',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - Validation errors`,
      },
    });
  }
  /**
   * Search orders by code, customer name, or email
   * @param term Search term (order code, customer name, or email)
   * @returns SalesOrder Search results
   * @throws ApiError
   */
  public static salesOrdersControllerSearch(term: string): CancelablePromise<Array<SalesOrder>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/search',
      query: {
        term: term,
      },
    });
  }
  /**
   * Get pending orders (confirmed and partial paid)
   * @returns SalesOrder Pending orders list
   * @throws ApiError
   */
  public static salesOrdersControllerGetPendingOrders(): CancelablePromise<Array<SalesOrder>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/pending',
    });
  }
  /**
   * Get dashboard data for order management
   * @returns any Dashboard data with orders requiring action
   * @throws ApiError
   */
  public static salesOrdersControllerGetDashboard(): CancelablePromise<{
    partialPaidOrders?: Array<SalesOrder>;
    overdueOrders?: Array<SalesOrder>;
    recentOrders?: Array<SalesOrder>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/dashboard',
    });
  }
  /**
   * Get sales daily KPI metrics
   * @param locationId Optional location filter
   * @param date Target date in ISO format (defaults to today)
   * @returns any
   * @throws ApiError
   */
  public static salesOrdersControllerGetSalesMetrics(
    locationId?: number,
    date?: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/metrics',
      query: {
        locationId: locationId,
        date: date,
      },
    });
  }
  /**
   * Get sales trend grouped by period
   * @param startDate Start date in ISO format
   * @param endDate End date in ISO format
   * @param groupBy Trend grouping
   * @param locationId Optional location filter
   * @returns any
   * @throws ApiError
   */
  public static salesOrdersControllerGetSalesMetricsTrend(
    startDate: string,
    endDate: string,
    groupBy?: 'day' | 'week' | 'month',
    locationId?: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/metrics/trend',
      query: {
        startDate: startDate,
        endDate: endDate,
        groupBy: groupBy,
        locationId: locationId,
      },
    });
  }
  /**
   * Get post-sales metrics (pending, completed, returned, exchanges)
   * @param locationId Optional location filter
   * @returns PostSalesCountsResponseDto Post-sales counts
   * @throws ApiError
   */
  public static salesOrdersControllerGetPostSalesCounts(
    locationId?: any,
  ): CancelablePromise<PostSalesCountsResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/post-sales-counts',
      query: {
        locationId: locationId,
      },
    });
  }
  /**
   * List sold pieces (availability SOLD only, all locations)
   * @param page
   * @param limit
   * @param productCodeUnique Código único de pieza
   * @param categoryName Nombre de categoría / tipo
   * @param saleDateFrom
   * @param saleDateTo
   * @param sellerId ID del vendedor (created_by)
   * @param sellerSearch Búsqueda por nombre de vendedor
   * @param locationId
   * @param hasCustomer true | false
   * @param customerSearch
   * @param finalPriceMin
   * @param finalPriceMax
   * @param orderCode
   * @param branchReceiptCode Número de recibo por sucursal
   * @param daysUntilSaleMin Mínimo de días (bloques de 24h) hasta la venta desde última transfer COMPLETED a la sucursal vendedora
   * @param daysUntilSaleMax Máximo de días (bloques de 24h) hasta la venta desde última transfer COMPLETED a la sucursal vendedora
   * @param supplierId ID del proveedor de la pieza (wip.supplier_id)
   * @returns SoldItemsListResponseDto
   * @throws ApiError
   */
  public static salesOrdersControllerFindSoldItems(
    page: number = 1,
    limit: number = 10,
    productCodeUnique?: string,
    categoryName?: string,
    saleDateFrom?: string,
    saleDateTo?: string,
    sellerId?: string,
    sellerSearch?: string,
    locationId?: number,
    hasCustomer?: boolean,
    customerSearch?: string,
    finalPriceMin?: number,
    finalPriceMax?: number,
    orderCode?: string,
    branchReceiptCode?: string,
    daysUntilSaleMin?: number,
    daysUntilSaleMax?: number,
    supplierId?: number,
  ): CancelablePromise<SoldItemsListResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/sold-items',
      query: {
        page: page,
        limit: limit,
        productCodeUnique: productCodeUnique,
        categoryName: categoryName,
        saleDateFrom: saleDateFrom,
        saleDateTo: saleDateTo,
        sellerId: sellerId,
        sellerSearch: sellerSearch,
        locationId: locationId,
        hasCustomer: hasCustomer,
        customerSearch: customerSearch,
        finalPriceMin: finalPriceMin,
        finalPriceMax: finalPriceMax,
        orderCode: orderCode,
        branchReceiptCode: branchReceiptCode,
        daysUntilSaleMin: daysUntilSaleMin,
        daysUntilSaleMax: daysUntilSaleMax,
        supplierId: supplierId,
      },
    });
  }
  /**
   * Export sold pieces to CSV
   * @param page
   * @param limit
   * @param productCodeUnique Código único de pieza
   * @param categoryName Nombre de categoría / tipo
   * @param saleDateFrom
   * @param saleDateTo
   * @param sellerId ID del vendedor (created_by)
   * @param sellerSearch Búsqueda por nombre de vendedor
   * @param locationId
   * @param hasCustomer true | false
   * @param customerSearch
   * @param finalPriceMin
   * @param finalPriceMax
   * @param orderCode
   * @param branchReceiptCode Número de recibo por sucursal
   * @param daysUntilSaleMin Mínimo de días (bloques de 24h) hasta la venta desde última transfer COMPLETED a la sucursal vendedora
   * @param daysUntilSaleMax Máximo de días (bloques de 24h) hasta la venta desde última transfer COMPLETED a la sucursal vendedora
   * @param supplierId ID del proveedor de la pieza (wip.supplier_id)
   * @returns any
   * @throws ApiError
   */
  public static salesOrdersControllerExportSoldItemsCsv(
    page: number = 1,
    limit: number = 10,
    productCodeUnique?: string,
    categoryName?: string,
    saleDateFrom?: string,
    saleDateTo?: string,
    sellerId?: string,
    sellerSearch?: string,
    locationId?: number,
    hasCustomer?: boolean,
    customerSearch?: string,
    finalPriceMin?: number,
    finalPriceMax?: number,
    orderCode?: string,
    branchReceiptCode?: string,
    daysUntilSaleMin?: number,
    daysUntilSaleMax?: number,
    supplierId?: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/sold-items/export/csv',
      query: {
        page: page,
        limit: limit,
        productCodeUnique: productCodeUnique,
        categoryName: categoryName,
        saleDateFrom: saleDateFrom,
        saleDateTo: saleDateTo,
        sellerId: sellerId,
        sellerSearch: sellerSearch,
        locationId: locationId,
        hasCustomer: hasCustomer,
        customerSearch: customerSearch,
        finalPriceMin: finalPriceMin,
        finalPriceMax: finalPriceMax,
        orderCode: orderCode,
        branchReceiptCode: branchReceiptCode,
        daysUntilSaleMin: daysUntilSaleMin,
        daysUntilSaleMax: daysUntilSaleMax,
        supplierId: supplierId,
      },
    });
  }
  /**
   * Sold piece detail (piece + order context for one line item)
   * @param salesOrderItemId
   * @returns SoldPieceDetailResponseDto
   * @throws ApiError
   */
  public static salesOrdersControllerFindSoldPieceDetail(
    salesOrderItemId: number,
  ): CancelablePromise<SoldPieceDetailResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/sold-items/{salesOrderItemId}/detail',
      path: {
        salesOrderItemId: salesOrderItemId,
      },
    });
  }
  /**
   * Get sales statistics by date range
   * @param startDate Start date (YYYY-MM-DD)
   * @param endDate End date (YYYY-MM-DD)
   * @returns any Sales statistics
   * @throws ApiError
   */
  public static salesOrdersControllerGetSalesStats(
    startDate: string,
    endDate: string,
  ): CancelablePromise<{
    totalOrders?: number;
    totalRevenue?: number;
    totalCost?: number;
    totalProfit?: number;
    averageOrderValue?: number;
    topSellingProducts?: any[];
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/stats',
      query: {
        startDate: startDate,
        endDate: endDate,
      },
    });
  }
  /**
   * Get orders by status
   * @param status
   * @returns SalesOrder Orders filtered by status
   * @throws ApiError
   */
  public static salesOrdersControllerFindByStatus(
    status: string,
  ): CancelablePromise<Array<SalesOrder>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/by-status/{status}',
      path: {
        status: status,
      },
    });
  }
  /**
   * Get orders by customer ID
   * @param customerId
   * @returns SalesOrder Customer orders
   * @throws ApiError
   */
  public static salesOrdersControllerFindByCustomer(
    customerId: number,
  ): CancelablePromise<Array<SalesOrder>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/by-customer/{customerId}',
      path: {
        customerId: customerId,
      },
    });
  }
  /**
   * Get orders by location ID
   * @param locationId
   * @returns SalesOrder Location orders
   * @throws ApiError
   */
  public static salesOrdersControllerFindByLocation(
    locationId: number,
  ): CancelablePromise<Array<SalesOrder>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/by-location/{locationId}',
      path: {
        locationId: locationId,
      },
    });
  }
  /**
   * Get orders by user ID (sales rep)
   * @param userId
   * @returns SalesOrder User orders
   * @throws ApiError
   */
  public static salesOrdersControllerFindByUser(
    userId: string,
  ): CancelablePromise<Array<SalesOrder>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/by-user/{userId}',
      path: {
        userId: userId,
      },
    });
  }
  /**
   * Get orders by date range
   * @param startDate
   * @param endDate
   * @param end End date (YYYY-MM-DD)
   * @param start Start date (YYYY-MM-DD)
   * @returns SalesOrder Orders in date range
   * @throws ApiError
   */
  public static salesOrdersControllerFindByDateRange(
    startDate: string,
    endDate: string,
    end: any,
    start: any,
  ): CancelablePromise<Array<SalesOrder>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/date-range',
      query: {
        startDate: startDate,
        endDate: endDate,
        end: end,
        start: start,
      },
    });
  }
  /**
   * Get sales order by ID
   * @param id
   * @returns SalesOrder Sales order details
   * @throws ApiError
   */
  public static salesOrdersControllerFindOne(id: number): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/{id}',
      path: {
        id: id,
      },
      errors: {
        404: `Order not found`,
      },
    });
  }
  /**
   * Update sales order
   * @param id
   * @param requestBody
   * @returns SalesOrder Sales order updated successfully
   * @throws ApiError
   */
  public static salesOrdersControllerUpdate(
    id: number,
    requestBody: UpdateSalesOrderDto,
  ): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/sales-orders/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `Access denied for this order location`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Delete sales order
   * @param id
   * @returns void
   * @throws ApiError
   */
  public static salesOrdersControllerRemove(id: number): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/sales-orders/{id}',
      path: {
        id: id,
      },
      errors: {
        403: `Access denied for this order location`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Get complete order with all relations
   * @param id
   * @returns SalesOrder Complete order details
   * @throws ApiError
   */
  public static salesOrdersControllerFindCompleteOrder(id: number): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/{id}/complete',
      path: {
        id: id,
      },
      errors: {
        404: `Order not found`,
      },
    });
  }
  /**
   * Get warehouse inventory product detail in sales order context (same payload as warehouse GET by id)
   * Requires sales order view_row; verifies the product is a current line item or appears in this order's item history (e.g. exchanged-out pieces).
   * @param id
   * @param wipId
   * @returns any Warehouse inventory product found
   * @throws ApiError
   */
  public static salesOrdersControllerFindWarehouseInventoryProductForOrder(
    id: number,
    wipId: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/{id}/warehouse-inventory-products/{wipId}',
      path: {
        id: id,
        wipId: wipId,
      },
      errors: {
        404: `Order or product not found, or product not on this order (line or history)`,
      },
    });
  }
  /**
   * Get product history for an order
   * @param id
   * @returns any Product history retrieved successfully
   * @throws ApiError
   */
  public static salesOrdersControllerGetOrderProductHistory(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/{id}/product-history',
      path: {
        id: id,
      },
    });
  }
  /**
   * Edit post-sale commercial data (customer, invoice, seller, sale date, and pricing if unpaid balance remains)
   * @param id
   * @param requestBody
   * @returns SalesOrder Sales order updated successfully
   * @throws ApiError
   */
  public static salesOrdersControllerUpdateCommercial(
    id: number,
    requestBody: UpdateSalesOrderCommercialDto,
  ): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/sales-orders/{id}/commercial',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid commercial edit`,
        403: `Missing permission or location access`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Confirm a sales order
   * @param id
   * @returns SalesOrder Order confirmed successfully
   * @throws ApiError
   */
  public static salesOrdersControllerConfirmOrder(id: number): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/{id}/confirm',
      path: {
        id: id,
      },
      errors: {
        400: `Order cannot be confirmed`,
        403: `Access denied for this order location`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Cancel a sales order
   * @param id
   * @returns SalesOrder Order cancelled successfully
   * @throws ApiError
   */
  public static salesOrdersControllerCancelOrder(id: number): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/{id}/cancel',
      path: {
        id: id,
      },
      errors: {
        400: `Order cannot be cancelled`,
        403: `Access denied for this order location`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Mark all deliverable pieces as delivered (legacy; prefer PATCH :id/delivery)
   * @param id
   * @returns SalesOrder Deliverable pieces marked as delivered
   * @throws ApiError
   */
  public static salesOrdersControllerMarkAsDelivered(id: number): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/{id}/deliver',
      path: {
        id: id,
      },
      errors: {
        400: `Order cannot be delivered`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Update per-item customer delivery flags
   * @param id
   * @param requestBody
   * @returns SalesOrder Delivery flags updated
   * @throws ApiError
   */
  public static salesOrdersControllerUpdateDelivery(
    id: number,
    requestBody: UpdateSalesOrderDeliveryDto,
  ): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/sales-orders/{id}/delivery',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid delivery update`,
        403: `Missing permission to set commercial deliveredAt`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Correct commercial sale date/time on a registered order (requires edit_sale_date)
   * @param id
   * @param requestBody
   * @returns SalesOrder Commercial sale date updated
   * @throws ApiError
   */
  public static salesOrdersControllerUpdateSaleDate(
    id: number,
    requestBody: UpdateSalesOrderSaleDateDto,
  ): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/sales-orders/{id}/sale-date',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid sale date or order status`,
        403: `Missing permission or location access`,
        404: `Order not found`,
      },
    });
  }
  /**
   * List commercial sale-date change history for an order
   * @param id
   * @returns SaleDateHistoryEntryDto Sale date change history
   * @throws ApiError
   */
  public static salesOrdersControllerGetSaleDateHistory(
    id: number,
  ): CancelablePromise<Array<SaleDateHistoryEntryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/{id}/sale-date-history',
      path: {
        id: id,
      },
      errors: {
        404: `Order not found`,
      },
    });
  }
  /**
   * Check if order is eligible for return/refund
   * @param id
   * @returns any Return eligibility information
   * @throws ApiError
   */
  public static salesOrdersControllerCheckReturnEligibility(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/{id}/return-eligibility',
      path: {
        id: id,
      },
      errors: {
        404: `Order not found`,
      },
    });
  }
  /**
   * Process full order return and refund
   * @param id
   * @param requestBody
   * @returns any Order returned and refunded successfully
   * @throws ApiError
   */
  public static salesOrdersControllerReturnOrder(
    id: number,
    requestBody: ReturnSalesOrderDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/{id}/return',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Order cannot be returned`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Process partial order return (specific items)
   * @param id
   * @param requestBody
   * @returns any Items returned and refunded successfully
   * @throws ApiError
   */
  public static salesOrdersControllerPartialReturnOrder(
    id: number,
    requestBody: PartialReturnSalesOrderDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/{id}/partial-return',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Items cannot be returned`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Update product status for order
   * @param id
   * @returns any Product status updated successfully
   * @throws ApiError
   */
  public static salesOrdersControllerUpdateProductStatus(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/{id}/update-product-status',
      path: {
        id: id,
      },
      errors: {
        403: `Access denied for this order location`,
      },
    });
  }
  /**
   * Peek next branch receipt code for a location (tentative; does not allocate)
   * @param locationId
   * @returns branchReceiptCode Next code when numbering is enabled; null when disabled
   * @throws ApiError
   */
  public static salesOrdersControllerPeekNextBranchReceiptCode(
    locationId: number,
  ): CancelablePromise<{
    branchReceiptCode?: string | null;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/next-branch-receipt-code/{locationId}',
      path: {
        locationId: locationId,
      },
      errors: {
        403: `Access denied for this location`,
      },
    });
  }
  /**
   * Generate a sample order code for testing
   * @param locationId
   * @returns any Generated order code
   * @throws ApiError
   */
  public static salesOrdersControllerGenerateOrderCode(locationId: number): CancelablePromise<{
    orderCode?: string;
    locationCode?: string;
    date?: string;
    sequenceNumber?: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/generate-order-code/{locationId}',
      path: {
        locationId: locationId,
      },
    });
  }
  /**
   * Check if order is eligible for exchange
   * @param id
   * @returns CheckExchangeEligibilityResponseDto Exchange eligibility information
   * @throws ApiError
   */
  public static salesOrdersControllerCheckExchangeEligibility(
    id: number,
  ): CancelablePromise<CheckExchangeEligibilityResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/{id}/exchange-eligibility',
      path: {
        id: id,
      },
      errors: {
        404: `Order not found`,
      },
    });
  }
  /**
   * Process order exchange
   * @param id
   * @param requestBody
   * @returns any Exchange processed successfully
   * @throws ApiError
   */
  public static salesOrdersControllerProcessExchange(
    id: number,
    requestBody: CreateExchangeDto,
  ): CancelablePromise<{
    order?: SalesOrder;
    exchangeSummary?: {
      originalItemsTotal?: number;
      newItemsTotal?: number;
      difference?: number;
      itemsExchanged?: number;
      newItemsCount?: number;
      paymentsProcessed?: number;
      exchangeDate?: string;
      processedBy?: string;
    };
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/{id}/exchange',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Exchange cannot be processed`,
        404: `Order not found`,
      },
    });
  }
}
